import React from 'react'

import { BasicViewProps } from 'constants/models'
import { Nursery } from 'services/nurseries/models'

import { Callout, Page, Section, Spinner } from 'components'

import i18n from 'translations'

import AddForm, { AddMedicationFormVales } from './components/AddForm'

interface AddViewProps extends BasicViewProps {
  childId: number
  errorMessages: string[]
  initialValues: AddMedicationFormVales
  isChildContext: boolean
  isDraftSubmitting: boolean
  isLongTerm: boolean
  nursery: Nursery
  onDeleteClick: () => void
  onSubmit: (fields: AddMedicationFormVales) => void
  onSubmitAsDraft: () => void
}

const AddView: React.FC<AddViewProps> = ({
  childId,
  errorMessages,
  initialValues,
  isChildContext,
  isDraftSubmitting,
  isEdit,
  isLoading,
  isLongTerm,
  isSubmitting,
  nursery,
  onDeleteClick,
  onSubmit,
  onSubmitAsDraft,
}) => {
  const renderContent = () => {
    if (isLoading) {
      return <Spinner />
    }

    return (
      <AddForm
        childId={childId}
        initialValues={initialValues}
        isChildContext={isChildContext}
        isDraftSubmitting={isDraftSubmitting}
        isLongTerm={isLongTerm}
        isSubmitting={isSubmitting}
        nursery={nursery}
        onSubmit={onSubmit}
        onSubmitAsDraft={onSubmitAsDraft}
      />
    )
  }

  return (
    <Page.Section
      actions={isEdit && (
        <Section.Actions options={[{ onClick: onDeleteClick, type: 'delete' }]} />
      )}
      title={isEdit
        ? i18n.t('module:Safeguarding:MedicationForm:Add:editTitle')
        : i18n.t('module:Safeguarding:MedicationForm:Add:title')}
    >
      <Callout content={errorMessages} error />
      {renderContent()}
    </Page.Section>
  )
}

export default AddView
